





























































































































































































































































import {
    ConfirmModal,
    ESearch,
    // FacetsFilters, // only used by the (commented out) filters panel
    Pagination,
    Scrollbar,
    // SearchTerms, // only used by the (commented out) searched filter terms/badges
    SvgImage,
    TwSegmentedTabs,
    TwSelect,
} from '@/app/components';
import { FacetFilterType, useFacetsFilters, useSearch } from '@/app/composable';
import { useRoute } from '@/app/composable/router';
import store from '@/app/store';
import { useAlerts } from '@/modules/alert/composable';
import { AlertSourceType } from '@/modules/alert/constants/alert.constants';
import { RefreshPageKeys } from '@/modules/notification/constants';
import { SearchAPI } from '@/modules/search/api';
import { ExclamationCircleIcon, PlusIcon, RefreshIcon } from '@vue-hero-icons/outline';
// FilterIcon is only used by the (commented out) filters panel toggle
// import { FilterIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent, onBeforeUnmount, ref, watch } from '@vue/composition-api';
import { OrbitSpinner } from 'epic-spinners';
import * as R from 'ramda';
import { ApolloAPI } from '../api';
import DataCheckinPipelineOverview from '../components/DataCheckinPipelineOverview.vue';
import FakeDataCheckinPipelineOverview from '../components/FakeDataCheckinPipelineOverview.vue';
import { useDataCheckinFilters } from '../composable';
import { DataCheckinSortingOption } from '../constants';
import { IndexedApolloPipeline } from '../types';

export default defineComponent({
    name: 'DataCheckinPipelines',
    metaInfo: {
        title: 'Ingestion Jobs',
    },
    components: {
        ConfirmModal,
        OrbitSpinner,
        DataCheckinPipelineOverview,
        SvgImage,
        Pagination,
        ExclamationCircleIcon,
        PlusIcon,
        TwSegmentedTabs,
        // FilterIcon,
        // FacetsFilters,
        TwSelect,
        // SearchTerms,
        FakeDataCheckinPipelineOverview,
        Scrollbar,
        RefreshIcon,
        ESearch,
    },
    setup(props, { root }) {
        const refresh = computed(() => {
            return store.state.notificationEngine.refresh[RefreshPageKeys.DataCheckinJob];
        });

        const searchableFields = [
            {
                label: 'title',
                key: 'name',
                textColorClasses: 'text-primary-700',
                backgroundClasses: 'bg-primary-700',
                highlightClasses: 'bg-primary-300',
                widthClasses: 'pl-16 ml-2',
            },
            {
                label: 'description',
                key: 'description',
                textColorClasses: 'text-teal-700',
                backgroundClasses: 'bg-teal-700',
                highlightClasses: 'bg-teal-300',
                widthClasses: 'pl-28 ml-2',
            },
        ];

        const { checkAlert, fetchAlerts } = useAlerts(root, [AlertSourceType.DataCheckin]);
        fetchAlerts();

        const route = useRoute();
        const highlightPipelineId = ref<string | null>(route.params.id); // Highlights a pipeline (when redirected from creating/updating, etc)

        // Delete confirmation modal and pointer
        const showDeleteModal = ref<boolean>(false);
        const toBeDeleted = ref<string | null>(null);
        const notificationReferenceType = ref(root.$route.params.type ?? null) as any;
        // Divisible by the 1/2/3 column counts of the cards grid, so the last row is never left half-empty
        const pageSize = 12;
        // Kept for the (commented out) filters panel; forced to false so the list uses the full width
        const openFilters = ref<boolean>(false);
        const pipelines = ref<IndexedApolloPipeline[]>([]);
        const rejectedItems = ref<number>(0);
        const totalResults = ref<number>(0);
        const user = ref(store.state.auth.user);

        const setSearchQuery = () => {
            searchQuery.value.filters =
                tab.value === 'mine'
                    ? Object.fromEntries(
                          Object.entries(reducedDataCheckinFilters).filter(([key]) => !key.includes('user')),
                      )
                    : reducedDataCheckinFilters;
        };

        const error = ref<any>(null);

        const search = () => {
            setCommonSearchQueryValues();

            searchQuery.value.pipelineType = 'data-checkin';

            searchQuery.value.settings = {
                organisationId: tab.value === 'shared' && user.value.organisationId ? user.value.organisationId : null,
                userId: user.value.id,
            };

            const api = tab.value === 'mine' ? SearchAPI.myJobsSearch : SearchAPI.sharedJobsSearch;

            setQueryParams();

            exec(api(searchQuery.value))
                .then((res: any) => {
                    pipelines.value = res.data?.results;
                    rejectedItems.value = res.data?.accessControl?.rejectedItems || 0;
                    totalResults.value = res.data?.total;
                    error.value = null;
                })
                .catch((e: any) => (error.value = e));
        };

        const {
            exec,
            loading,
            get,
            textNumberFilters,
            page,
            sortBy,
            tab,
            query,
            searchQuery,
            setTab,
            updateCurrentPage,
            filterChanged,
            sortByChanged,
            clearFilters,
            setCommonSearchQueryValues,
            setQueryParams,
            unsubscribeSearch,
            sortingFields,
        } = useSearch(root, 'data-checkin-jobs', pageSize, DataCheckinSortingOption, 'mine', setSearchQuery, search);
        onBeforeUnmount(() => {
            unsubscribeSearch.value ? unsubscribeSearch.value() : undefined;
            if (refresh.value) store.dispatch.notificationEngine.disableRefreshAction(RefreshPageKeys.DataCheckinJob);
        });

        const scopeTabs = computed(() => [
            { key: 'mine', label: 'Mine' },
            { key: 'shared', label: 'Shared with me' },
        ]);

        const { dataCheckinFilters, reducedDataCheckinFilters } = useDataCheckinFilters(get);
        const { calculateSearchedFilters, defaultValue } = useFacetsFilters();

        const filtersInfo = computed(() => {
            switch (tab.value) {
                case 'mine':
                    return Object.fromEntries(
                        Object.entries(dataCheckinFilters.value).filter(([key]) => !key.includes('user')),
                    );
                default:
                    return dataCheckinFilters.value;
            }
        });

        const allOption = { value: null, label: 'All' };

        /**
         * The options of a checkbox filter, prepended with an "All" option that clears the filter
         * @param filterKey The checkbox filter key
         */
        const singleFilterOptions = (filterKey: string) =>
            computed(() => [allOption, ...(filtersInfo.value[filterKey]?.options ?? [])]);

        /**
         * The single active value of a checkbox filter, null when the filter is not applied
         * @param filterKey The checkbox filter key
         */
        const singleFilterValue = (filterKey: string) =>
            computed(() => searchQuery.value.filters[filterKey]?.[0] ?? null);

        const statusOptions = singleFilterOptions('status');
        const harvestingOptions = singleFilterOptions('harvestingOption');
        const statusValue = singleFilterValue('status');
        const harvestingOptionValue = singleFilterValue('harvestingOption');

        /**
         * Applies a checkbox filter as a single-choice one. Any previously selected value is removed
         * in place (without searching) and the new one is toggled through filterChanged, so that the
         * query parameters are updated and the search is executed exactly once.
         * @param filterKey The checkbox filter key
         * @param value The newly selected value, null when "All" is selected
         */
        const singleFilterChanged = (filterKey: string, value: any) => {
            const current = searchQuery.value.filters[filterKey] ?? [];
            if (current.length === 1 && current[0] === value) return;

            if (R.isNil(value)) {
                if (!current.length) return;
                // keep a single value around so that toggling it off empties the filter
                const remaining = current[current.length - 1];
                current.splice(0, current.length - 1);
                filterChanged(filterKey, remaining, FacetFilterType.Checkbox);
                return;
            }

            current.splice(0, current.length);
            filterChanged(filterKey, value, FacetFilterType.Checkbox);
        };

        watch(showDeleteModal, (value: boolean) => {
            if (!value) toBeDeleted.value = null;
        });

        const edit = (id: string) => {
            root.$router.push({ name: 'data-checkin-jobs:edit', params: { id } });
        };

        const openHistory = (id: string) => {
            root.$router.push({ name: 'data-checkin-jobs:history', params: { id } });
        };

        const confirmDelete = (id: string) => {
            toBeDeleted.value = id;
            showDeleteModal.value = true;
        };

        const destroy = async () => {
            if (toBeDeleted.value) {
                const idx = R.findIndex(R.propEq('id', toBeDeleted.value), pipelines.value as any[]);
                if (~idx) {
                    showDeleteModal.value = false;
                    try {
                        const referenceId = toBeDeleted.value;
                        await exec(ApolloAPI.delete(toBeDeleted.value));

                        store.commit.notificationEngine.SET_NOTIFICATIONS_AFTER_REFERENCED_ITEM_DELETE({
                            referenceId,
                            referenceType: notificationReferenceType.value
                                ? notificationReferenceType.value
                                : 'data-checkin',
                        });
                        (root as any).$toastr.s('Ingestion Job deleted successfuly', 'Success');
                        page.value = 1;
                        updateCurrentPage();
                    } catch (e: any) {
                        if (e.response?.data?.message === 'Locked')
                            (root as any).$toastr.e('The Ingestion Job is locked', 'Error');
                        else (root as any).$toastr.e('Deleting Ingestion Job failed', 'Error');
                    }
                }
            }
        };

        const retryExecution = async (pipelineId: string) => {
            await exec(ApolloAPI.run(pipelineId))
                .then(() => {
                    (root as any).$toastr.s('Ingestion Job resubmitted for execution');
                    search();
                })
                .catch(() => {
                    (root as any).$toastr.e('Ingestion Job resubmission failed', 'Error');
                });
        };

        const clonePipeline = async (pipelineId: string) => {
            (root as any).$router.push({ name: 'data-checkin-jobs:clone', params: { id: pipelineId } });
        };

        const currentSearchedFilters = computed(() =>
            calculateSearchedFilters(searchQuery.value.filters, filtersInfo.value),
        );

        const refreshPage = () => {
            search();
            store.dispatch.notificationEngine.disableRefreshAction(RefreshPageKeys.DataCheckinJob);
        };
        textNumberFilters.value = { pipeline: defaultValue(get, 'pipeline', false) };
        setSearchQuery();
        search();

        return {
            confirmDelete,
            destroy,
            edit,
            error,
            pipelines,
            loading,
            pageSize,
            showDeleteModal,
            page,
            openHistory,
            retryExecution,
            clonePipeline,
            scopeTabs,
            setTab,
            tab,
            filterChanged,
            clearFilters,
            openFilters,
            query,
            searchQuery,
            sortingFields,
            sortByChanged,
            sortBy,
            updateCurrentPage,
            currentSearchedFilters,
            totalResults,
            rejectedItems,
            filtersInfo,
            textNumberFilters,
            refresh,
            refreshPage,
            highlightPipelineId,
            checkAlert,
            searchableFields,
            statusOptions,
            harvestingOptions,
            statusValue,
            harvestingOptionValue,
            singleFilterChanged,
        };
    },
});
